import { cn } from "@/lib/utils";
import React from "react";

type Props = React.HTMLAttributes<HTMLDivElement>;

/** The floating pill at bottom-right that holds the bot icon when the
 * agent is minimised. Shared between the per-org agent session and the
 * admin-home agent entry so both have identical placement + styling. */
export const AgentMinimizedIcon = React.forwardRef<HTMLDivElement, Props>(
  ({ className, children, ...rest }, ref) => (
    <div
      ref={ref}
      {...rest}
      className={cn(
        "fixed bottom-0 right-0 z-50 mx-4 my-8 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-card p-2 text-card-foreground shadow-lg transition-transform hover:scale-110",
        className,
      )}
    >
      {children}
    </div>
  ),
);
AgentMinimizedIcon.displayName = "AgentMinimizedIcon";
